module.exports = __webpack_public_path__ + "img/AK_logo_no_text.32d74111.svg";